import { put, takeLatest } from 'redux-saga/effects';
import { consts as leaveCommunityConsts } from '../leaveCommunity';
import { actions as membersActions } from '../communityMembers';
import { actions as moderatorActions } from '../communityModerators';
import { actions as communityActions } from '../currentCommunityInfo';

function* leaveCommunityWorker() {
  yield put(membersActions.clearMembers());
  yield put(moderatorActions.clearModerators());
  yield put(communityActions.clearUserRole());
}

export default function* leaveCommunitySaga() {
  yield takeLatest(leaveCommunityConsts.SUCCEED, leaveCommunityWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/leaveCommunity.js